// extracted by mini-css-extract-plugin
export default {"recommend":"CRecommend_recommend__Jv4D9","order":"CRecommend_order__v4aPt"};